import { type ConfSamplePageLocation } from './parse-twc-trigger-conf-tour-trait';

/**
 * Builds a Confluence onboarding URL from hostname and twc-trigger-conf-tour trait value.
 * @param hostname - The hostname from TCS (e.g., "example.atlassian.net")
 * @param location - The ConfluencePageLocation
 * @returns The constructed Confluence URL, or undefined if inputs are invalid
 */
export const getConfluenceOnboardingUrl = (
	hostname: string | undefined,
	location: ConfSamplePageLocation | null,
): string | undefined => {
	if (!hostname || !location) {
		return undefined;
	}

	const { spaceId, pageId } = location;

	return `${hostname}/wiki/spaces/${spaceId}/pages/${pageId}`;
};
